import { Component, inject } from '@angular/core';
import { ListboxModule } from 'primeng/listbox';
import { ISidebarNavItem } from '../sidebar/sidebar.interface';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'app-burger-menu',
  imports: [ListboxModule],
  templateUrl: './burger-menu.html',
  styleUrl: './burger-menu.css',
})
export class BurgerMenu {
  private accountService = inject(AccountService);

  protected isVerified = this.accountService.isVerified;

  tabs: Pick<ISidebarNavItem, 'name'>[] = this.isVerified()
    ? [
      { name: 'Signalements' },
      { name: 'Paramètres' },
      { name: 'Déconnexion' }
    ]
    : [
      { name: 'Paramètres' },
      { name: 'Déconnexion' }
    ];
}
